<template>
  <v-dialog
    :model-value="modelValue"
    :fullscreen="computedFullscreen"
    :width="width"
    :max-width="maxWidth"
    :scrollable="scrollable"
    :persistent="persistent"
    @update:model-value="onUpdateModelValue"
  >
    <v-card
      class="app-modal-card"
      :loading="loading"
      :disabled="disabled"
    >
      <!-- En-tête -->
      <v-card-title class="d-flex align-center justify-space-between app-modal-header">
        <slot name="title">
          <span class="text-h6 font-weight-bold">{{ title }}</span>
        </slot>
        <div class="d-flex align-center">
          <slot name="header-actions" />
          <v-btn
            v-if="showClose"
            icon
            variant="text"
            size="small"
            title="Fermer"
            :disabled="loading"
            class="ml-2"
            @click="handleClose"
          >
            <v-icon size="large">
              mdi-close
            </v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <!-- Corps du dialogue (défilant si scrollable=true) -->
      <v-card-text :class="['app-modal-body', bodyClass]">
        <slot />
      </v-card-text>

      <!-- Pied d'actions -->
      <v-card-actions
        v-if="showActions"
        class="app-modal-actions"
      >
        <slot name="actions">
          <v-btn
            v-if="canDelete"
            color="error"
            variant="text"
            :loading="deleteLoading"
            :disabled="disabled || loading"
            @click="$emit('delete')"
          >
            {{ deleteText }}
          </v-btn>

          <slot name="prepend-actions" />

          <v-spacer />

          <v-btn
            v-if="showCancel"
            variant="text"
            :disabled="disabled || loading"
            @click="handleCancel"
          >
            {{ cancelText }}
          </v-btn>

          <v-btn
            v-if="showSave"
            color="primary"
            variant="flat"
            :loading="saveLoading || loading"
            :disabled="disabled || !canSave"
            @click="$emit('save')"
          >
            {{ saveText }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AppModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: [String, Number],
      default: "600"
    },
    maxWidth: {
      type: [String, Number],
      default: undefined
    },
    scrollable: {
      type: Boolean,
      default: true
    },
    persistent: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    bodyClass: {
      type: String,
      default: "pa-4"
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showActions: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showSave: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: "Annuler"
    },
    saveText: {
      type: String,
      default: "Enregistrer"
    },
    deleteText: {
      type: String,
      default: "Supprimer"
    },
    canSave: {
      type: Boolean,
      default: true
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    saveLoading: {
      type: Boolean,
      default: false
    },
    deleteLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update:modelValue",
    "save",
    "cancel",
    "delete",
    "close"
  ],
  computed: {
    computedFullscreen() {
      if (this.fullscreen !== null) {
        return this.fullscreen;
      }
      return this.$vuetify.display.xs;
    }
  },
  methods: {
    onUpdateModelValue(val) {
      this.$emit("update:modelValue", val);
      if (!val) {
        this.$emit("close");
      }
    },
    handleClose() {
      this.$emit("update:modelValue", false);
      this.$emit("close");
      this.$emit("cancel");
    },
    handleCancel() {
      this.$emit("update:modelValue", false);
      this.$emit("cancel");
      this.$emit("close");
    }
  }
};
</script>
